// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"c9f15f1b","23":"7bf46d3b","188":"1a6cae29","245":"1c63e6a9","509":"9de2c65f","540":"0d409418","574":"c20f0e82","737":"f2d5db26","873":"669d3f1a"}[chunkId] + ".chunk.js";
};